// ink-component
import React from 'react';
import Actions from './components/LedgerWrapperActions/LedgerWrapperActions';
import Filter from './components/LedgerWrapperFilter/LedgerWrapperFilter';
import Pagination from './components/LedgerWrapperPagination/LedgerWrapperPagination';
import Search from './components/LedgerWrapperSearch/LedgerWrapperSearch';
import TopBar from './components/LedgerWrapperTopBar/LedgerWrapperTopBar';
import BottomBar from './components/LedgerWrapperBottomBar/LedgerWrapperBottomBar';

export interface LedgerWrapperProps {}

/**
 * @purpose Wrapper to nest useLedger subcomponents
 * @categories table
 * @group ledger
 */

const LedgerWrapper = (props: LedgerWrapperProps) => {
  return <></>;
};

LedgerWrapper.Actions = Actions;
LedgerWrapper.Filter = Filter;
LedgerWrapper.Pagination = Pagination;
LedgerWrapper.Search = Search;
LedgerWrapper.TopBar = TopBar;
LedgerWrapper.BottomBar = BottomBar;

export { ActionsProps } from './components/LedgerWrapperActions/LedgerWrapperActions';
export { FilterProps, FilterItems } from './components/LedgerWrapperFilter/LedgerWrapperFilter';
export { PaginationProps } from './components/LedgerWrapperPagination/LedgerWrapperPagination';
export { SearchProps } from './components/LedgerWrapperSearch/LedgerWrapperSearch';
export { TopBarProps } from './components/LedgerWrapperTopBar/LedgerWrapperTopBar';
export { BottomBarProps } from './components/LedgerWrapperBottomBar/LedgerWrapperBottomBar';

LedgerWrapper.displayName = 'LedgerWrapper';

export default LedgerWrapper;
